import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import SignatureCanvas from 'react-signature-canvas'
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';


import Bs4GenericField from './Bs4GenericField';
import Bs4MainDispatch from '../../Bs4MainDispatch';
import Bs4Kartoteka from '../../Bs4Kartoteka';
import * as Bs4Utils from '../../Bs4Components/Bs4Utils'

export default class Bs4Signature extends Bs4GenericField {  

  getValueBs4() {
    return [this.getValue()?.id] || null;
  }

  gatherFormValues() {
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(this.optionId);
    return bs4Option.bs4Form.gatherFormValues();
  }

  elementSetStore = (store) => {
    //console.log('... File ... ELEMENT_SET_STORE ... store', store);
    if (Array.isArray(store)) {
      if (store.length === 1) {
        this.setValue(store[0]);
      } else {
        console.log('===Error=== ELEMENT_SET_STORE, store.lenhgt != 1:', store);  
      }
    } else {
      console.log('===Error=== ELEMENT_SET_STORE, store:', store);
    }
  }

  updateFilesJson = (returnedJson) => {
    console.log('... File updateFilesJson ...', returnedJson)
    let items = [];

    if (Array.isArray(returnedJson.messgs)) {                
      items = returnedJson.messgs;
    } else if (returnedJson.messgs) {
      items = [returnedJson.messgs];
    }

    items.forEach(item => {
      if (item.data) {        
        this.updateFiles(item.data)
      } else if ('_Typ' in item) {        
        Bs4MainDispatch.parsingBs4ResponseMessagges(item, this.props.bs4KartotekaId)
      } else {
        console.log('===Error=== updateFiles item:', item)
      }
    })              
  }

  dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",")
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[arr.length - 1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  uploadBs4Signature = (data) => {
    if (!data) return;
    const file = this.dataURLtoFile(data, 'Bs4Signature_'+Bs4Utils.toDateTime(new Date()))
    console.log('...file...', file);
    const formData = new FormData();
    formData.append(this.props.field.formId + '_file_' + file.name, file);
    const fields = this.gatherFormValues();
    const details = { 
      currFormId: this.props.field.formId,
      formData: fields.fieldsDict,
      currCardViewId: this.bs4KartotekaId, 	
      currOptionId: this.optionId,
    };

    //console.log('... File upload .1.', details)

    formData.append('allparams', JSON.stringify( Bs4MainDispatch.getParserParams(details, this.bs4KartotekaId) ));

    fetch(Bs4MainDispatch.getUrlPath('web.php?com=Bs4UploadFile'), {method: 'POST', body: formData})
    .then(response => response.text())
    .then(returnedText => {
      try {
        const returnedJson = JSON.parse(returnedText);
        this.updateFilesJson(returnedJson);
        console.log('...file.update..', returnedJson);
        this.updateFile = false;
      } catch (e) {
        console.log(e);
        console.log(returnedText);
      }
    })
    .catch((error) => {
      console.log(error);
      this.updateFile = false;
    })
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(null)
    const [open, setOpen] = React.useState(false)
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    this.refFocus = React.useRef();

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue() || null);
        // console.log('...Bs4Signature..CHANGE.???.', this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);            
    
    const handleOpen = (event) => {      
      setOpen(true)
    }

    const handleOk = (event) => {      
      const dataURL =  this.refFocus.current.getTrimmedCanvas().toDataURL('image/png');      
      this.uploadBs4Signature(dataURL);
      setOpen(false)
    }
    
    const handleCancel = (event) => {      
      setOpen(false)
    }

    const link = value?.id ? Bs4MainDispatch.getUrlPath('showp.php?mid='+value?.id) : null;
    console.log('...Bs4Signature...', value, link)

    return (
      <FormControl fullWidth error={error.error}>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Box>
        {link ? 
          <img src={link} style={{maxWidth:'100%', loading: 'lazy', objectFit: 'scale-down'}} onClick={handleOpen}/>
        : 
          <IconButton onClick={handleOpen}>
            <i className="fa-regular fa-file-signature"/>
          </IconButton>
        }        
        </Box>          
        <Dialog 
          open={open}
          PaperProps={{sx: { width: '100%', height:'100%', maxWidth: '90%', maxHeight: '90%', }}}
        >
          <DialogTitle>{'Signature'}</DialogTitle>
          <DialogContent>
            <SignatureCanvas 
              ref={this.refFocus}
              penColor='#0a0aaa'
              canvasProps={{style: {width: '100%', height: '99%', padding: '10px'}}}                
            />   
          </DialogContent>
          <DialogActions>          
            <Button onClick={handleCancel}>Anuluj</Button>
            <Button onClick={handleOk}>Ok</Button>
          </DialogActions>
        </Dialog>        
      </FormControl>
    );
  }
}